import React, { FunctionComponent } from 'react';
import { JobOffer } from '../../../domain/graphcms';
import {
  buildJobOfferURLObject, goToPage, normalizeJobOfferProvince, slugIt,
} from '../../utils/links';
import JobOfferCard from '../job-offer-card/JobOfferCard';
import * as styles from './JobOffers.style';

export interface JobOffersProps {
  items: JobOffer[],
  inline?: number,
}

const JobOffers: FunctionComponent<JobOffersProps> = ({
  items,
  inline = 2,
}) => (
  <ul css={styles.items}>
    {items.map((offer) => (
      <li
        data-ref="job-offer"
        key={offer.id}
        css={styles.item}
        $inline={inline}
      >
        <JobOfferCard
          title={offer.jobPosition.name}
          location={normalizeJobOfferProvince(offer)}
          onClick={() => goToPage(buildJobOfferURLObject({
            id: offer.id,
            slug: `${slugIt(offer.jobPosition.name)}-${slugIt(normalizeJobOfferProvince(offer))}`,
          }))}
        />
      </li>
    ))}
  </ul>
);

export default JobOffers;
